var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider } from '@material-ui/core/styles';
import TaskPropDialog from '../CreateDialogue/TaskVariableDialog';
import EditTaskPropDialog from '../EditDialogue/EditTaskTypeDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,permissions,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');


export default function TaskVariablesTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [isLoading, setIsLoading] = React.useState(true);
    const [taskTypes, setTaskTypes] = React.useState([
    ]);

    const handleDialogCallback = (childData) => {
        fetch("api/task_variable", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "task_variable": [{
                    "Name": childData.Name,
                    "IsDropdown": childData.IsDropdown,
                    "Validation": childData.Validation,
                    "IsActive": childData.IsActive
                }],
                "task_prop_item": childData.PropList
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("api/task_variable", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "task_variable": {
                    "ID": childData.ID,
                    "Name": childData.Name,
                    "IsDropdown": childData.IsDropdown,
                    "Validation": childData.Validation,
                    "IsActive": childData.IsActive
                },
                "task_prop_item": childData.PropList
            })
        })
        logger({
            "the Child Data": childData
        });
        setRefresh(true);
    };

    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
            fetch('api/task_variable', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setTaskTypes(json);
					setIsLoading(false);
				})
            setRefresh(false);
        }

    })

	const columns = [];
	if (permissions.CreateTasks == 1) {
		const adminActions = {
			name: "Admin Actions",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRenderLite: (dataIndex, rowIndex) => {
					return (
						<div>
							<EditTaskPropDialog handleEditCallback={handleEditCallback} data={taskTypes[dataIndex]} />
						</div>
					);
				}

			}
		};
		columns.push(adminActions);
	}
	const columns1 = [
		{
			name: "Name",
			label: "Name",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
			name: "IsDropdown",
			label: "Type",
			options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                        	{taskTypes[dataIndex].IsDropdown==0 ? "Text field" : "Dropdown"}
                        </div>
                    );
                }
            }
        },
      	{
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                filterList: [1],
                customFilterListOptions:
                {
                    render: v => {
                        if (v === 0) {
                            return "Show InActive";
                        }
                        if (v === 1) {
                            return "Show Active";
                        }
                        return val;
                    },
                },
                filterOptions: {
                    renderValue: val => {
                        if (val === 0) {
                            return "InActive";
                        }
                        if (val === 1) {
                            return "Active";
                        }
                        return val;
                    }
                }, 
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                        	{(taskTypes[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
		}	
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('TaskVariablesrowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('TaskVariablesrowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    columns.push(...columns1);

	const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'TasKVariables.xlsx', columnIndexToRemove:0})
			return false;
		},
        customToolbar: () => permissions.CreateTaskVariables===1 && !isLoading  ? (<TaskPropDialog handleDialogCallback={handleDialogCallback} />):(<></>)
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (       
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="TaskTypesTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Task Variables
                        </Typography>
                    }
                    data={isLoading ? [] :taskTypes}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
        </Box>
        
    );
}